import Anticancer from "../../constants/img/Anticancer.jpeg";
import Therapeutic from "../../constants/img/Therapeutic.jpeg";
import Binding from "../../constants/img/Binding.png";
import Affinity from "../../constants/img/Affinity.png";

import { Outlet, useLocation, useNavigate } from "react-router";
import { useMemo } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  Container,
  Grid,
  Slide,
  Typography,
  useTheme,
} from "@mui/material";

const imgs = [Anticancer, Therapeutic, Binding, Affinity];
const types = ["Anticancer", "Therapeutic", "Binding", "Affinity"];
const paths = types.map((type) => type.toLowerCase());

export default function ServerHome({ title, descriptions }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const lastPath = location.pathname.match(/[^/]+$/)[0];
  const inChild = paths.includes(lastPath);

  const buttons = useMemo(
    () =>
      descriptions.map((desc, index) => (
        <Grid
          item
          xs={inChild ? 3 : 12}
          sm={inChild ? 3 : 12}
          md={3}
          key={index}
        >
          <Card
            elevation={3}
            sx={{
              height: "100%",
            }}
            onClick={() => navigate(types[index].toLowerCase())}
          >
            <CardActionArea>
              <Collapse in={!inChild}>
                <Box
                  height={300}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src={imgs[index]}
                    alt={types[index]}
                    style={{
                      width: "calc(100% - 40px)",
                      maxHeight: "calc(100% - 20px)",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Collapse>
              <CardContent
                sx={{
                  borderBottom: "4px solid",
                  paddingBottom: "calc(10px - 0.35em)",
                  borderBottomColor:
                    lastPath === paths[index]
                      ? theme.palette.secondary.main
                      : "transparent",
                  transition: "border-bottom-color .3s ease-in-out",
                }}
              >
                <Typography
                  gutterBottom
                  variant={inChild ? "h6" : "h5"}
                  component="div"
                >
                  {types[index]}
                </Typography>
                <Collapse in={!inChild}>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {desc}
                  </Typography>
                </Collapse>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      )),
    [descriptions, navigate, inChild, lastPath, theme]
  );

  return (
    <Container sx={{ paddingBottom: 3 }}>
      <Collapse in={!inChild}>
        <Typography variant="h4" component="div" align="center" margin={5}>
          {title}
        </Typography>
      </Collapse>

      <Grid
        container
        spacing={3}
        marginTop={1}
        sx={
          {
            // transformOrigin: "top center",
            // transform: inChild ? "scale(.8)" : "",
            // transition: "transform .3s ease-out",
          }
        }
      >
        {buttons}
      </Grid>

      <Slide direction="up" in={inChild} mountOnEnter appear={false}>
        <Box sx={{ marginTop: 2 }}>
          <Outlet />
        </Box>
      </Slide>
    </Container>
  );
}
